<script setup lang="ts">
import { useDebounceFn } from "@vueuse/core";
const config = useRuntimeConfig();

const { $sanitizeHtml } = useNuxtApp();
const isDesktopApp = ref<boolean>(true);
const isResizingBody = ref<boolean>(true);
const prevWidth = ref(1920);

provide("sanitize", $sanitizeHtml);
provide("isDesktopApp", isDesktopApp);
provide("isResizingBody", isResizingBody);

useHead({
  link: [
    {
      rel: "icon",
      type: "image/png",
      sizes: "16x16",
      href: `${config.public.pngSize16}`
    },
    {
      rel: "icon",
      type: "image/png",
      sizes: "32x32",
      href: `${config.public.pngSize32}`
    },
    {
      rel: "apple-touch-icon",
      type: "image/png",
      sizes: "180x180",
      href: `${config.public.pngSize180}`
    }
  ],
  meta: [{ property: "fb:admins", content: `${config.public.socialfbAdmin}` }]
});

const setBreakpointsApp = () => {
  isDesktopApp.value = window.innerWidth > 1024;
};

const resizeDebouncedFn = useDebounceFn((entries) => {
  const width = entries[0].borderBoxSize?.[0].inlineSize;
  if (width !== prevWidth.value) {
    setBreakpointsApp();
    isResizingBody.value = !isResizingBody.value;
    prevWidth.value = width;
  }
}, 50);

onMounted(() => {
  setBreakpointsApp();
  prevWidth.value = window.innerWidth;
  const resizeObserver = new ResizeObserver(resizeDebouncedFn);
  resizeObserver.observe(document.body, { box: "border-box" });
});
</script>

<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
